import { ClientGet } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";
import { getIdWithCompany } from "../utils/id";
import { Client } from "./interfaces";

export const makeClient = ({ connection, company }: ApiSliceParams) => {
    const {
        items: clients,
        allLoading: loading,
        listen: listenCompany,
    } = createListController<ClientGet, Client, string>({
        name: "client",
        connection,
        list: (con, company) => con.client.items({ company }),
        view: (item, company) => ({
            ...item,
            company,
            id: getIdWithCompany(item.id, company),
            _id: item.id,
        }),
        getId: (item, company) => getIdWithCompany(item.id, company),
        getKey: (company) => company,
    });

    const getByCode = (code: string) =>
        clients.value.find((c) => c.client === code);

    const listen = () => listenCompany(company.value);

    return { clients, loading, listen, listenCompany, getByCode };
};
